import { inputFunc } from "../../lib/inputFunctions";
import "./input.css";

type TextInputProps = {
  state: { [key: string]: any };
  setState:
    | React.Dispatch<React.SetStateAction<{ [key: string]: any }>>
    | React.Dispatch<React.SetStateAction<{ [key: string]: any }[]>>;
  stateKey: string;
  label?: string;
  inlineLabel?: string;
  labelWidth?: number;
  placeholder?: string;
  afterText?: string;
  type?: string;
  errorMessage?: string;
  pattern?: { [key: string]: any };
  required?: boolean;
  readonly?: boolean;
  format?: "toNumber" | "toPhoneNumber" | "toMoney" | "toVatnumber" | "toInteger";
  itemOfArr?: { [key: string]: any };
};

export function TextInput({
  state,
  stateKey,
  setState,
  label,
  inlineLabel,
  labelWidth,
  placeholder,
  afterText,
  type = "text",
  pattern,
  required,
  readonly,
  format,
  itemOfArr,
}: TextInputProps) {
  const valid = new RegExp(pattern ? pattern.pattern : "").test(state[stateKey]?.toString() ?? "");

  return (
    <div className="input-container">
      {label && (
        <div className="input-label">
          <label>{label}</label>
        </div>
      )}
      <div className="input-wrapper">
        {inlineLabel && (
          <div style={{ width: labelWidth }} className="input-inline-label">
            {inlineLabel}
          </div>
        )}
        <div className="inputfield-wrapper">
          <input
            id={stateKey}
            name={stateKey}
            className={`inputfield ${inlineLabel && "inlinelabeled"} ${afterText && "aftertext"}`}
            type={type}
            value={state[stateKey] ?? ""}
            onChange={(e) =>
              itemOfArr
                ? inputFunc.changeObjOfArr(itemOfArr, e.target.value, setState, stateKey, format)
                : inputFunc.changeObj(e.target.value, setState, stateKey, format)
            }
            placeholder={placeholder}
            pattern={pattern && pattern.pattern}
            required={required}
            readOnly={readonly}
          />
        </div>
        {afterText && <div className="input-after">{afterText}</div>}
      </div>
      {pattern && state[stateKey] && !valid && <div className="input-error">{pattern.message}</div>}
    </div>
  );
}
